import Loadable from 'components/Loadable';
import { lazy } from 'react';
import { RouteObject } from 'react-router';

const ListFiturKuasa = Loadable(lazy(() => import('./index')));

export const routes: RouteObject[] = [
    {
        path: 'laporan/list-fitur-kuasa',
        element: <ListFiturKuasa />,
    },
];
